export default "__VITE_ASSET__Czivgc4A__"